/**
 * Determines if a Date instance is valid.
 * @param date The date.
 * @returns Boolean value.
 */
export function isValidDate(date: Date) {
	return date instanceof Date && !isNaN(date.getTime());
}